import { createContext } from 'react'
import { type LanguageContextModel } from './LanguageContextModel'

const initialContext = {
  selectedLanguage: 'en_US',
}

export const LanguageContext =
  createContext<LanguageContextModel>(initialContext)

LanguageContext.displayName = 'Language'
